<template>
  <div class="container">
    <div class="progressbar">
      <a
        v-for="(step, index) in steps"
        :href="step.selector"
        :style="liWidth"
        :class="{
          'active': step.active,
          'active-line': index < continuousCompletedSteps,
          'in-progress': index === continuousCompletedSteps,
          'no-link': !step.selector }"
          v-smooth-scroll
        class="small">
        <span>{{ step.text }}</span>
        <span class="progress-icon"></span>
      </a>
    </div>
  </div>
</template>

<style>

.progressbar a {
  margin-top: 1rem;
  list-style-type: none;
  float: left;
  position: relative;
  text-align: center;
  color: var(--secondary);
  text-decoration: none;
}
.progressbar a.no-link {
  cursor: default;
}
.progressbar a:hover {
  color: var(--secondary);
}
.progressbar a.active:hover, .progressbar a.in-progress:hover {
  color: var(--primary);
}
/*the circle */
.progressbar a:before {
  width: 20px;
  height: 20px;
  content: '';
  line-height: 20px;
  border: 2px solid var(--secondary);
  display: block;
  text-align: center;
  margin: 0 auto 10px auto;
  border-radius: 50%;
  background-color: var(--light);
}
/* the line before the circle */
.progressbar a:after {
  width: 100%;
  height: 2px;
  content: '';
  position: absolute;
  background-color: var(--secondary);
  top: 9px;
  left: -50%;
  z-index: -1;
}
.progressbar a:first-child:after {
  display: none;
}
.progressbar a.in-progress .progress-icon:before {
  content: '';
  width: 8px;
  height: 8px;
  background-color: var(--primary);
  border-radius: 50%;
  position: absolute;
  top: 6px;
  left: calc(50% - 4px);
}
.progressbar a.active, .progressbar a.in-progress {
  color: var(--primary);
}
.progressbar a.active:before, .progressbar a.in-progress:before {
  border-color: var(--primary);
}
.progressbar a.active:before {
  background-color: var(--primary);
}
.progressbar a.active .progress-icon:before {
  color: var(--primary);
  position: absolute;
  top: -0.65rem;
  left: calc(50% - 0.9rem);
  font-family: icomoon;
  content: "\e912";
  font-size: 1.7rem;
}
.progressbar a.active-line + a:after {
  background-color: var(--primary);
}
</style>

<script>
export default {
  props: {
    steps: { required: true, type: Array }
  },
  computed: {
    liWidth() {
      let widthPercentage = ((1 / this.steps.length) * 100).toString() + '%';
      return { width: widthPercentage };
    },
    /*we don't want to fill in the line after, ie, step 3, if only steps 1 and 3 are complete
    so this determines how many steps have been completed for line-filling purposes
    also determines which step should get a lil circle in indicate that it should be done next
    */
    continuousCompletedSteps() {
      let i = 0;
      for (let step of this.steps) {
        if( step.active ) {
          i++;
        } else {
          break;
        }
      }
      return i;
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ProgressTracker.vue